import { useGridRootProps as useCommunityGridRootProps } from "@mui/x-data-grid-premium";
import { DataGridPremiumProcessedProps } from "@mui/x-data-grid-premium/models/dataGridPremiumProps";
import "../models/dataGridProps.ts";

export const useGridRootProps = useCommunityGridRootProps as () => DataGridPremiumProcessedProps;